<template>
  <div class="alert row mx-0 mb-4" :class="`alert-${type}`" role="alert">
    <div class="col-1 p-0 d-flex text-right alert-icon">
      <icon class="my-auto ml-2" :name="iconName"></icon>
    </div>
    <div class="col-11 pl-0 py-2" v-html="content"></div>
  </div>
</template>

<script>

  import 'vue-awesome/icons/check-circle'
  import 'vue-awesome/icons/info-circle'
  import 'vue-awesome/icons/exclamation-triangle'
  import 'vue-awesome/icons/exclamation-circle'

  export default {

    props: [
      'type',
      'content'
    ],

    computed: {
      iconName() {
        switch (this.type) {
          case this.$enums.alerts.types.success:
            return 'check-circle'
          case this.$enums.alerts.types.primary:
            return 'info-circle'
          case this.$enums.alerts.types.warning:
            return 'exclamation-triangle'
          case this.$enums.alerts.types.danger:
            return 'exclamation-circle'
        }
      }
    }
  }
</script>

<style scoped>
  .alert-icon {
    max-width: 60px
  }
</style>
